module.exports = __webpack_public_path__ + "static/media/silence.2b5bb705.mp3";